
const pinImage = require('!url-loader?mimetype=image/png!./pin-white.png');

export default function(options = {}) {
  if (!supportsTouch()) {
    return loadStandardPinWidget();
  }

  options.selector || 'body';

  let images = document.querySelectorAll(`${options.selector} img`);
  for (let i = 0; i < images.length; i++) {
    let image = images[i];
    image.parentNode.style.display  = 'block';
    image.parentNode.style.position = 'relative';

    image.parentNode.appendChild(createPinButton(image));
  }

  document.addEventListener('click', function(e) {
    if (!e.target.dataset || !e.target.dataset.pinMedia) {
      return;
    }

    e.preventDefault();
    openPinItWindow(e.target.dataset.pinMedia, e.target.alt);
  });
}

function openPinItWindow(media, description = '') {
  let url = `https://www.pinterest.com/pin/create/button/`
          + `?url=${window.location.href}&media=${media}&description=${description}`;

  window.open(url, 'pinit', 'width=450,height=300,resizable,scrollbars=yes,status=1');
}

function createPinButton(originalImage) {
  let img = document.createElement('img');
  img.src = pinImage;
  img.style.position = 'absolute';
  img.style.bottom = '10px';
  img.style.right = '10px';

  img.dataset.pinMedia = originalImage.src;

  return img;
}

function supportsTouch() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

function loadStandardPinWidget() {
  let script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.dataset.pinHover = 'true';
  script.dataset.pinTall = 'true';
  script.src = '//assets.pinterest.com/js/pinit.js';

  document.body.appendChild(script);
}



// WEBPACK FOOTER //
// ./src/frontend/pinterest/index.js